import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { brandSvg, withBrandMarks } from '../brand-marks';

/// A SitePage's HTML, ready for [innerHTML]. The server renders the markdown and sanitises it (raw HTML stripped,
/// SitePagesController), so it is trusted here - Angular's own sanitiser would drop the headings' ids the sections
/// link to. Each table is wrapped in a box of its own (.site-table) that scrolls sideways on a phone, so a wide table
/// never widens the page. `siteHtml:true` also puts each brand's mark before its name (the PrimeCommerce and Sell
/// pages - the owner, 2026-10-23: "logos everywhere"); the legal pages keep plain text. A third argument, a set the
/// caller keeps for one section, makes it one mark a brand across everything the section says.
@Pipe({
    name: 'siteHtml'
})
export class SiteHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(html: string, marks: boolean = false, seen?: Set<string>): SafeHtml {
        let wrapped = String(html || '')
            .replace(/<table\b/gi, () => '<div class="site-table"><table')
            .replace(/<\/table>/gi, () => '</table></div>');
        if (marks) { wrapped = withBrandMarks(wrapped, seen); }
        return this.sanitizer.bypassSecurityTrustHtml(wrapped);
    }
}

/// Plain text (a landing pill, a stat's caption) as HTML with each brand's mark before its name: the text is escaped first, so
/// nothing in it is read as markup.
@Pipe({
    name: 'brandText'
})
export class BrandTextPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(text: string): SafeHtml {
        const escaped = String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        return this.sanitizer.bypassSecurityTrustHtml(withBrandMarks('<span>' + escaped + '</span>'));
    }
}

/// A brand's mark as HTML, for a page outside the panel that names one in its own template (the courier-charges tool).
@Pipe({
    name: 'brandMark'
})
export class BrandMarkPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }

    transform(name: string, size: number = 20): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(`<span class="brand-mark" aria-hidden="true">${brandSvg(name, size)}</span>`);
    }
}
